var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstatePremise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 16,
    height: 16,
    viewBox: "0 0 80 80",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce85",
    d: "M2.5 61.655L2.5 42.974 40.014 16.602 77.5 40.546 77.5 61.655 40 77.458z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M40.027,17.204L77,40.821v20.503L40,76.915L3,61.323v-18.09L40.027,17.204 M40,16L2,42.714v19.273 L40,78l38-16.013V40.273L40,16L40,16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5ddf5",
    d: "M40 45.459L2.5 60.966 2.5 18.345 40 2.542 77.5 18.345 77.5 60.966z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M40,3.085l37,15.592v41.542L40.382,45.076L40,44.918l-0.382,0.158L3,60.219V18.677L40,3.085 M40,2 L2,18.013v43.701L40,46l38,15.714V18.013L40,2L40,2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f6ff",
    d: "M77,60.219L40.382,45.076L40,44.918l-0.382,0.158L40,3.085l37,15.592V60.219z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc49c",
    d: "M48.5 48.974L48.5 16.753 67.5 24.746 67.5 56.831z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M49,17.506l18,7.573v31.005L49,48.64V17.506 M48,16v33.308l20,8.271V24.414L48,16L48,16z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M13.5 25.852L30.5 18.291 30.5 36.311 13.5 43.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M30,19.061v16.922l-16,6.969V26.177L30,19.061 M31,17.522l-18,8.006v18.951l18-7.84V17.522 L31,17.522z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M63 38A1 1 0 1 0 63 40A1 1 0 1 0 63 38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstatePremise);
export default __webpack_public_path__ + "static/media/estate_premise.05e95db54367147f55f312399d720a5c.svg";
export { ForwardRef as ReactComponent };